/* =========================================
   COLLECTION BANNERS – FINAL VERSION
   Facets + Infinite Scroll Safe
========================================= */

(function () {

  let bannerTimeout = null;

  /* -----------------------------------------
     Create banner element (image / video)
  ----------------------------------------- */
  function createBannerItem({ image, video, link, index }) {
    const bannerClass = `imagen-collection-page__middle imagen-collection-page__middle--${index}`;

    let mediaHTML = '';

    if (video) {
      mediaHTML = `
        <video
          src="${video}"
          autoplay
          muted
          loop
          playsinline
          preload="metadata"
        ></video>
      `;
    } else if (image) {
      mediaHTML = `<img src="${image}" alt="">`;
    } else {
      return null;
    }

    return $(`
      <li class="column product-item-imagen ${bannerClass}">
        <div class="container-imagen">
          ${
            link
              ? `<a href="${link}" target="_blank">${mediaHTML}</a>`
              : mediaHTML
          }
        </div>
      </li>
    `);
  }

  /* -----------------------------------------
     Main banner handler (IDEMPOTENT)
  ----------------------------------------- */
  function handleCollectionBanners() {
    const $grid = $('#product-grid');
    if (!$grid.length) return;

    // 🔒 Short lock (avoid simultaneous runs)
    if ($grid.data('banners-processing')) return;
    $grid.data('banners-processing', true);

    const rawData = $grid.attr('data-collection-banners');
    if (!rawData) {
      $grid.removeData('banners-processing');
      return;
    }

    let data;
    try {
      data = JSON.parse(rawData);
    } catch (e) {
      console.error('[BANNERS] Invalid JSON', e);
      $grid.removeData('banners-processing');
      return;
    }

    const banners = data.banners || [];
    if (!banners.length) {
      $grid.removeData('banners-processing');
      return;
    }

    // ⚠️ Only real products (exclude banners)
    const $products = $grid
      .find('li.column')
      .not('.imagen-collection-page__middle');

    banners.forEach((banner, i) => {
      const bannerIndex = i + 1;
      const positionIndex = banner.position - 1;

      // Not enough products yet (important for infinite scroll)
      if ($products.length <= positionIndex) return;

      // Banner already exists → do nothing (idempotent)
      if ($grid.find(`.imagen-collection-page__middle--${bannerIndex}`).length) {
        return;
      }

      const $bannerItem = createBannerItem({
        image: banner.image,
        video: banner.video,
        link: banner.link,
        index: bannerIndex
      });

      if ($bannerItem) {
        $products.eq(positionIndex).after($bannerItem);
      }
    });

    // 🔓 Release lock quickly
    setTimeout(() => {
      $grid.removeData('banners-processing');
    }, 80);
  }

  /* -----------------------------------------
     Facets + Infinite Scroll Observer
  ----------------------------------------- */
  function initFacetsObserver() {
    const container = document.querySelector('#ProductGridContainer');
    if (!container) return;

    const observer = new MutationObserver(() => {
      clearTimeout(bannerTimeout);

      bannerTimeout = setTimeout(() => {
        handleCollectionBanners();
      }, 80);
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });
  }

  /* -----------------------------------------
     Init
  ----------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    handleCollectionBanners();   // Initial render
    initFacetsObserver();        // Facets / sort / scroll
  });

  /* -----------------------------------------
     Back navigation video fix (optional)
  ----------------------------------------- */
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.product-item-imagen video').forEach(video => {
      video.pause();
      video.currentTime = 0;
      video.play().catch(() => {});
    });
  });

})();
